import { __exportAll } from "../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/interface-content-folder.svg
var interface_content_folder_exports = /* @__PURE__ */ __exportAll({
	default: () => interface_content_folder_default,
	render: () => render
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M216 72h-85.33l-27.74-20.8a16.12 16.12 0 0 0-9.6-3.2H40a16 16 0 0 0-16 16v136a16 16 0 0 0 16 16h176.89A15.13 15.13 0 0 0 232 200.89V88a16 16 0 0 0-16-16m0 128H40V64h53.33l29.87 22.4A8 8 0 0 0 128 88h88Z" }, null, -1)])]);
}
var interface_content_folder_default = { render };
//#endregion
export { interface_content_folder_default as default, interface_content_folder_exports, render };

//# sourceMappingURL=interface-content-folder.svg.js.map